export default "__VITE_ASSET__Dk76Q7d0__"